import { Injectable } from '@angular/core';
import {HttpClientService} from './http-client.service';
import {AppConfigService} from './app-config.service';
import {Order} from './app-models/models';
import {Headers} from '@angular/http';

@Injectable()
export class CreateOrderService {

  private apiUrl = AppConfigService.settings.apiUrl + 'orders/';

  constructor(private http: HttpClientService) {
  }

  Authenticate(): Promise<any[]> {
    return this.http.get(this.apiUrl + 'permission')
      .toPromise()
      .then(response => response.json() as any[])
      .catch(this.handleError);
  }

  createOrder(data: Order): Promise<Order> {
    const headers = new Headers({ 'Content-Type': 'application/json' });
    return this.http.post(this.apiUrl + 'create', JSON.stringify(data), headers)
      .toPromise()
      .then(response => response.json() as Order)
      .catch(this.handleError);
  }

  private handleError(error: any): Promise<any> {
    console.error('An error occurred', error); // for demo purposes only
    return Promise.reject(error.message || error);
  }

}



// WEBPACK FOOTER //
// ./src/app/create-order.service.ts